import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { TaskPerson, taskInitials } from '../../services/tasks.service';

/** Round avatar with initials when there is no usable photo. Sizes: 20–40px. */
@Component({
  selector: 'tk-avatar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (person && person.profileImg && !failed()) {
      <img class="tk-av" [style.width.px]="size" [style.height.px]="size" [src]="person.profileImg" [alt]="person.name" (error)="failed.set(true)" [title]="title || person.name" />
    } @else {
      <span class="tk-av tk-av-txt" [style.width.px]="size" [style.height.px]="size" [style.font-size.px]="size * 0.38" [title]="title || person?.name || ''">{{ initials() }}</span>
    }
  `,
  styles: [
    `
      :host { display: inline-flex; flex: none; line-height: 0; }
      .tk-av { border-radius: 50%; object-fit: cover; display: inline-grid; place-items: center; background: var(--tk-brand-soft, #ecedf8); color: var(--tk-brand-ink, #3f3e7a); font-weight: 600 !important; letter-spacing: 0.02em; overflow: hidden; line-height: 1; }
      .tk-av-txt { user-select: none; }
    `,
  ],
})
export class TaskAvatarComponent {
  @Input() person: TaskPerson | null | undefined;
  @Input() size = 28;
  @Input() title = '';
  readonly failed = signal(false);
  readonly initials = computed(() => taskInitials(this.person?.name || this.person?.userName));
}
